/* global axios */
import JwtAuth from './jwtAuth';
import { buildIdempotentHeaders } from 'dashboard/api/helpers/inboxMwHeaders';

const baseUrl =
  process.env.FRONTEND_ENV === 'develop'
    ? 'https://staging.chatlyn.com/inboxmw'
    : `${window.location.protocol}//${window.location.host}/inboxmw`;

class InboxMiddlewareAPI {
  async getInbox(inboxId, accountId) {
    const jwtAuthTokens = await JwtAuth.getUserTokens();

    const url = accountId
      ? `${baseUrl}/inboxes/${inboxId}?accountId=${accountId}`
      : `${baseUrl}/inboxes/${inboxId}`;

    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${jwtAuthTokens.access_token}`,
      },
    });
  }

  async getConfiguration(accountId) {
    const jwtAuthTokens = await JwtAuth.getUserTokens();

    return axios.get(
      `${baseUrl}/configurations/effective?accountId=${accountId}`,
      {
        headers: {
          Authorization: `Bearer ${jwtAuthTokens.access_token}`,
        },
      }
    );
  }

  // Note: This endpoint has @SkipIdempotency() on the backend, so no Idempotency-Key header is required
  async createWebchatInbox(payload) {
    const jwtAuthTokens = await JwtAuth.getUserTokens();

    return axios.post(`${baseUrl}/chatlyn/accounts`, payload, {
      headers: {
        Authorization: `Bearer ${jwtAuthTokens.access_token}`,
      },
    });
  }

  async softDeleteInbox(inboxId, accountId) {
    const jwtAuthTokens = await JwtAuth.getUserTokens();

    const url = `${baseUrl}/chatlyn/inboxes/${inboxId}?accountId=${accountId}`;
    const headers = buildIdempotentHeaders(jwtAuthTokens.access_token);

    return axios.delete(url, { headers });
  }

  async permanentlyDeleteInbox(inboxId, accountId) {
    const jwtAuthTokens = await JwtAuth.getUserTokens();

    const url = `${baseUrl}/chatlyn/inboxes/${inboxId}/permanent?accountId=${accountId}`;
    const headers = buildIdempotentHeaders(jwtAuthTokens.access_token);

    return axios.delete(url, { headers });
  }
}

export default new InboxMiddlewareAPI();
